export default __webpack_public_path__ + "static/media/editIcon.b9a61022.svg";